module.exports = __webpack_public_path__ + "static/dolly2-da30bf0c23f6164c540f2cf22d4d4336.jpg";